import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import "./Applications.css";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import PropTypes from "prop-types";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ActivityDetails, ITEMS_PER_PAGE } from "../../utils/constants";
import { failed, success } from "../../utils/Tostify";
import { useDispatch, useSelector } from "react-redux";
import { decryptData } from "../../utils/helper";
import { createApplicationActivity, getAllApplication, updateApplicationArchieve, updateApplicationById } from "../../api/Applications";
import CustomPagination from "../../components/Pagination/CustomPagination";
import moment from "moment";
import { calculateAge } from "../../utils/DateSupport";
import { MenuItem, Select } from "@mui/material";
import { getStaffsByOrgId } from "../../api/User";
import Loader from "../../components/Loader/Loader";
import MultiSelectCheckbox from "../../components/InputFields/MultiSelectWithCheckboc";
import { columnApplicationOptions, stageStatusOption } from "./Constant";
import Search from "../../components/InputFields/Search";
import Stepper from "react-stepper-horizontal";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
import DynamicFilterDropdown from "../../components/Filters/Filter";
import { applyFilters, decryptPatientData } from "../../utils/common";
import { deleteFilter } from "../../api/filters";
import { getPatients } from "../../api/patient";
import { resetCurrentPage, setCurrentPage, setCustomFilteredApplications, setListFilter, setSearchKey, setSelectedCustomFilters, setSortBy } from "../../context/reducers/adminApplnState";

function AdminApplications({ direction, ...args }) {
  const [dropdownState, setDropdownState] = useState({});
  const togglefour = (filterId) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [filterId]: !prevState[filterId]
    }));
  };
  let token = useSelector((state) => state.userReducer.token);
  const [applicationList, setApplicationlist] = useState([]);
  const [patients, setPatients] = useState([]);
  const navigate = useNavigate();
  const searchKey = useSelector((state) => state.adminApplicationReducer.searchKey);
  const currentPage = useSelector(state => state.adminApplicationReducer.currentPage);
  const [rowsPerPage] = useState(ITEMS_PER_PAGE);
  const [filteredApplications, setFilteredApplication] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [expandedOrg, setExpandedOrg] = useState([]);
  const [staffList, setStaffOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(
    columnApplicationOptions.map((option) => option.value)
  );
  const [countofList, setCountOfList] = useState();
  const location = useLocation();
  const listFilter = useSelector((state) => state.adminApplicationReducer.listFilter);
  const sortBy = useSelector((state) => state.adminApplicationReducer.sortBy);
  const [selectedCheckbocOption, setSelectedCheckboxOption] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [applicationNote, setNote] = useState('');
  const [editingApln, setEditingApln] = useState({});
  const { getConfirmation } = useConfirmDialog();
  const [selectedFilter, setSelectedFilter] = useState([]);
  const selectedCustomFilter = useSelector((state) => state.adminApplicationReducer.selectedCustomFilter);
  const customFilteredApplications = useSelector((state) => state.adminApplicationReducer.customFilteredApplications);

  const getApplicationList = async (page, limit, searchKey = "") => {
    let res;
    try {
      setIsLoading(true);
      // setSearch(searchKey);
      res = await getAllApplication({
        dispatch,
        token,
        listFilter,
        clinicId : localStorage.getItem("currentHospitalId")
      });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setApplicationlist(responseData);
        setCountOfList(responseData?.filterCounts);
        setFilteredApplication(responseData?.list?.items);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const getPatientList = async () => {
      let res;
      try {
        setIsLoading(true);
        res = await getPatients({ dispatch, token, listFilter: "all", orgId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId") });
        if (res?.status === "SUCCESS") {
          const responseData = decryptData(res.data);
          if (responseData?.list) {
            const decryptedPatients = await Promise.all(
              responseData.list.map(async (patient) => {
                return decryptPatientData(patient);
              })
            );
            setPatients({ ...responseData, items: decryptedPatients });
          }
          setIsLoading(false);
        }
      } catch (error) {
        failed(res?.message);
        setIsLoading(false);
      }
    };

  useEffect(() => {
    if(listFilter !== ""){
      getApplicationList();
    }
  }, [listFilter]);

  useEffect(() => {
    getPatientList();
  },[]);

  const handleSearch = (e) => {
    dispatch(setSearchKey(e.target.value));
    dispatch(resetCurrentPage());
  };

  useEffect(() => {
    if (applicationList?.list?.items) {
      let tempApplications = [...applicationList.list.items];
      if (selectedCustomFilter?.length > 0) {
        tempApplications = applyFilters(selectedCustomFilter, tempApplications, "Application");
      }

      if ((searchKey || "").trim() !== "") {
        const lowercasedSearchKey = searchKey.toLowerCase();
        tempApplications = tempApplications.filter((apln) => {
          const aplnName = apln?.title?.toLowerCase() || "";
          return aplnName.includes(lowercasedSearchKey);
        });
      }

      if (sortBy.column) {
        const sortDirection = sortBy.desc ? 1 : -1;
        tempApplications.sort((a, b) => {
          const valA = (a?.title || "").toLowerCase();
          const valB = (b?.title || "").toLowerCase();
          return valA.localeCompare(valB) * sortDirection;
        });
      }

      setFilteredApplication(tempApplications);
    }
  }, [applicationList, searchKey, sortBy, selectedCustomFilter]);

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedApplications = filteredApplications?.slice(
    startIndex,
    endIndex
  );

  const handlePagination = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleExpand = (id) => {
    setExpandedOrg((prev) =>
      prev.includes(id) ? prev.filter((orgId) => orgId !== id) : [...prev, id]
    );
  };

  const getStaffList = async (page, limit, searchKey = "") => {
    let res;
    try {
      setIsLoading(true);
      setSearchKey(searchKey);
      res = await getStaffsByOrgId({dispatch, token, page, limit, searchKey, orgId: localStorage.getItem("currentOrgId"), currentHospitalId : localStorage.getItem("currentHospitalId"), dataLimit: "all"});
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        const dropdownData = responseData?.items?.map((staff) => ({
          label: `${staff.firstName} ${staff.lastName}`,
          value: staff._id
        }));
        setStaffOptions(dropdownData);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getStaffList();
  }, []);

  const handleUpdate = async (aplnId, payload, patientId) => {
    let res;
    try {
      setIsLoading(true);
      res = await updateApplicationById({ payload, dispatch, token, aplnId });
      const responseData = decryptData(res.data);
      if (res?.status == "SUCCESS") {
        success(res?.message);
        let values = {
          type : "Application",
          event : payload?.consultantId ? ActivityDetails?.AdminAssignment.event : ActivityDetails?.NotesAdded.event,
          applicationId : aplnId,
          clinicId: localStorage.getItem("currentHospitalId"),
          organizationId: localStorage.getItem("currentOrgId"),
          patientId : patientId,
          details : payload?.consultantId ? ActivityDetails?.AdminAssignment?.details : ActivityDetails?.NotesAdded?.details
        };
        await createApplicationActivity({ values, dispatch, token });
        setIsLoading(false);
        await getApplicationList();
        setEditingApln(false);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      failed(res?.message);
    }
  };

  const handleSort = (column) => {
    const newSortBy = {
      column,
      desc: sortBy.column === column ? !sortBy.desc : false
    };
    dispatch(setSortBy(newSortBy));
  };

  const handleColumn = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleFilter = (status) => {
    dispatch(setListFilter(status));
    dispatch(resetCurrentPage());
    dispatch(setSelectedCustomFilters(null));
  };

  const handleSelect = (id) => {
    if (selectedCheckbocOption.includes(id)) {
      setSelectedCheckboxOption(selectedCheckbocOption.filter(item => item !== id));
    } else {
      setSelectedCheckboxOption([...selectedCheckbocOption, id]);
    }
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      // Deselect all
      setSelectedCheckboxOption([]);
    } else {
      // Select all
      const allIds = paginatedApplications.map(patient => patient._id);
      setSelectedCheckboxOption(allIds);
    }
    setIsSelectAll(!isSelectAll);
  };

  useEffect(() => {
    // Update isSelectAll based on the current state of selectedOption and paginatedApplications
    const allIds = paginatedApplications?.map(patient => patient._id);
    setIsSelectAll(allIds?.length > 0 && allIds.every(id => selectedCheckbocOption.includes(id)));
  }, [selectedCheckbocOption, paginatedApplications]);

  const isChecked = (id) => selectedCheckbocOption.includes(id);

  const handleArchieve = async (aplnId, patientId) => {
    let res;
    try {
      let statusArchieve = listFilter === "archieve" ? false : true;
      setIsLoading(true);
      res = await updateApplicationArchieve({ values: { applicationIds: selectedCheckbocOption, archieve: statusArchieve }, dispatch, token });
      if (res?.status === "SUCCESS") {
        // let values = {
        //   type : "Application",
        //   event : ActivityDetails.ApplicationArchived.event,
        //   applicationId : aplnId,
        //   clinicId: localStorage.getItem("currentHospitalId"),
        //   organizationId: localStorage.getItem("currentOrgId"),
        //   patientId : patientId,
        //   details : ActivityDetails.ApplicationArchived.details
        // };
        // let res = await createApplicationActivity({ values, dispatch, token });
        await getApplicationList();
        setIsLoading(false);
        success(res?.message);
        setIsSelectAll(false);
        setSelectedCheckboxOption([]);
        setCurrentPage(1);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleNoteChange = (applicationId, value) => {
    setNote((prevState) => ({ ...prevState, [applicationId]: value })); // Update note text for specific patient
  };

  const handleEditClick = (applicationId) => {
    setEditingApln((prevState) => ({ ...prevState, [applicationId]: true })); // Enable editing mode for specific patient
  };

  const handleDeleteClick = async (aplnId, payload) => {
    let res;
    try {
      const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: `Are you sure want to Delete Note`
      });
      if (confirmed) {
        setIsLoading(true);
        res = await updateApplicationById({ payload, dispatch, token, aplnId });
        const responseData = decryptData(res.data);
        if (res?.status == "SUCCESS") {
          setIsLoading(false);
          await getApplicationList();
          setEditingApln(false);
          success(res?.message);
          setNote("");
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const applyPatientFilters = (filters) => {
    let result = applicationList?.list?.items;
    const filtered = applyFilters(filters, result, "Application");
    setFilteredApplication(filtered);
  };

  const handleFilterSelect = (filter) => {
    const newFilters = filter.filters;
    const result = applicationList?.list?.items || [];

    const filteredList = applyFilters(newFilters, result, "Application");

    dispatch(setSelectedCustomFilters(newFilters));
    dispatch(setCustomFilteredApplications(filteredList));
    dispatch(resetCurrentPage());
    dispatch(setSortBy({ column: "", desc: false }));

    // IMPORTANT: Set listFilter to "all" so base list is 'All Applications'
    dispatch(setListFilter("all"));
  };

  const getCustomApplicationFilterCount = (filter) => {
    if (!filter?.filters || !Array.isArray(applicationList?.allApplicationsList)) {
      return 0;
    }
    const filteredApplications = applicationList.allApplicationsList.filter((application) => {
      return filter.filters.every((filterItem) => {
        const { field, value, operator } = filterItem;
        if (field === "assigned_to") {
          const assignedToOrConsultant = application.assigned_to || application.consultantId;
          return assignedToOrConsultant === value;
        }
        // 🔥 Handle "contains" operator for fields like Application Title
        if (operator === "contains") {
          const fieldValue = application[field];
          return fieldValue?.toLowerCase().includes(value?.toLowerCase());
        }
        // Default strict match
        return application[field] === value;
      });
    });
    return filteredApplications.length;
  };

  const handleFilterDelete  = async(id) =>{
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName: "",
      actionBtnTitle: "Yes",
      message: `Are you sure you want to delete Filter?`
    });
    if (confirmed) {
        let res;
        try {
            const values = {filterId: id};
            setIsLoading(true);
            res = await deleteFilter({values, dispatch, token});
            if (res?.status === "SUCCESS") {
                setIsLoading(false);
                await getApplicationList();
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
      }
  };

  useEffect(() => {
      localStorage.setItem("prevRoute", window.location.pathname);
    }, []);

    useEffect(()=>{
      localStorage.removeItem('prevRoute2');
    },[]);

  const hasEligiblePatient = patients?.list?.some(patient => patient.system_ai_care === "Yes") ?? false;

  const activeCustomFilterTitle = useMemo(() => {
    if (selectedCustomFilter?.length > 0 && applicationList?.filterList?.length > 0) {
      const matchedFilter = applicationList.filterList.find(filter => {
        return JSON.stringify(filter.filters) === JSON.stringify(selectedCustomFilter);
      });
      return matchedFilter?.title || null;
    }
    return null;
  }, [selectedCustomFilter, applicationList]);

  useEffect(() => {
    if (location.state?.listFilter) {
      dispatch(setListFilter(location.state.listFilter));
    }
  }, [location.state, dispatch]);

    const calculatePendingTasks = (tasks) => {
        return tasks.filter((task) => task.status !== "Completed").length;
    };
  return (
    <Fragment>
      {isLoading ? <Loader /> : null}
      <div className="dashboard_container  admin_application_container p-0 table_listing_color admin_list_app_data">
        <div className="d-flex justify-content-between align-items-end main-header-block m-0">
          <div className="left_admin_list_pro">
            <h2 className="home-title p-0">Applications</h2>
          </div>
          <div className="right_admin_list_pro">
            <div className="right_header d-flex align-items-center gap-2">
            <button
              className="application_add p-0"
              style={{whiteSpace:"nowrap"}}
              onClick={() => {
                const prevRoute = localStorage.getItem("prevRoute");
                const isRouteMode4 = prevRoute === "	/app/admin-application";
                localStorage.setItem("isRouteMode3", JSON.stringify(isRouteMode4));
                navigate("/app/start-application", { state: { applicationList } });
              }}
              disabled={!hasEligiblePatient}
              >
              <i className="fa fa-plus"></i> Start Application
            </button>
              <div className="drop_block">
                <MultiSelectCheckbox
                  options={columnApplicationOptions}
                  selectedOptions={selectedOption}
                  onChange={handleColumn}
                  placeholder="All Columns"
                  sx={{ width: '180px' }}
                />
              </div>
              <DynamicFilterDropdown onFilterChange={applyPatientFilters} type="Application" selectedFilters={selectedCustomFilter} staffList={staffList} columnOptions={columnApplicationOptions} refetch={getApplicationList}/>
              <Search
                value={searchKey}
                onChange={(e) => handleSearch(e)}
              />
              <button className="new_patient archeive" style={{backgroundColor : "#E44545", color : "#ffffff"}} disabled={selectedCheckbocOption.length === 0} onClick={() => handleArchieve()}>{listFilter === "archieve" ? "UnArchive" : "Archive"}</button>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-lg-2 col-md-12 nav_side">
            <Nav vertical className="gap-2">
            <NavItem className={(listFilter === "assigned-me" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink
                  href="#"
                  onClick={() => handleFilter("assigned-me")}
                  className="d-flex justify-content-between dashbord_nav mb-2"
                >
                  Assigned to me
                  <span>{countofList?.assignedMe ? countofList?.assignedMe : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "all" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink
                  href="#"
                  onClick={() => handleFilter("all")}
                  className="d-flex justify-content-between dashbord_nav mb-2"
                >
                  All Application
                  <span>{countofList?.allPatient ? countofList?.allPatient : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "InProcess" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink
                  href="#"
                  onClick={() => handleFilter("InProcess")}
                  className="d-flex justify-content-between dashbord_nav mb-2"
                >
                  In Process
                  <span>{countofList?.InProcess ? countofList?.InProcess : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "Completed" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink
                  href="#"
                  onClick={() => handleFilter("Completed")}
                  className="d-flex justify-content-between dashbord_nav mb-2"
                >
                  Completed
                  <span>{countofList?.Completed ? countofList?.Completed : 0}</span>
                </NavLink>
              </NavItem>
              <NavItem className={(listFilter === "archieve" && !activeCustomFilterTitle) ? 'active' : ''}>
                <NavLink
                  href="#"
                  onClick={() => handleFilter("archieve")}
                  className="d-flex justify-content-between dashbord_nav mb-2"
                >
                  Archived
                  <span>{countofList?.Archieve ? countofList?.Archieve : 0}</span>
                </NavLink>
              </NavItem>
              {applicationList?.filterList?.length > 0 && <h4 className="main-views mt-2 mb-2 d-flex justify-content-between align-items-center">Custom Filters</h4>}
              {applicationList?.filterList?.length > 0 && applicationList?.filterList?.map((filter) => (
                 <div key={filter._id}>
              <NavItem key={filter._id} className={activeCustomFilterTitle === filter.title ? 'active' : ''}>
                <NavLink href="#" className="d-flex justify-content-between dashbord_nav mb-2" key={filter?._id} onClick={() => {handleFilterSelect(filter);}}>
                {filter.title} ({getCustomApplicationFilterCount(filter)})
                </NavLink>
                <Dropdown  isOpen={dropdownState[filter._id] || false}
                  toggle={() => togglefour(filter._id)} className="drop_down">
                <DropdownToggle caret size="xl" className="filter_block_blk">
                  <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => handleFilterDelete(filter?._id) }>
                    Delete View
                  </DropdownItem>
                </DropdownMenu>
                </Dropdown>
              </NavItem>
              </div>
              ))
              }
            </Nav>
          </div>
          <div className="col-lg-10 col-md-12 table_space">
            <div className="table-responsive">
              <table>
                <thead>
                  <tr className="header_table">
                    <th className="check_in p-0">
                      <Form className="all_check p-0">
                        <FormGroup
                          check
                          inline
                        >
                          <Input
                            type="checkbox"
                            checked={isSelectAll}
                            onChange={handleSelectAll}
                          />
                        </FormGroup>
                      </Form>
                    </th>
                    <th className="p-0"></th>
                    {selectedOption.length !== 0 && selectedOption.includes("title") && (<th>
                      Application Title{" "}
                      <i
                        className="fas fa-sort"
                        onClick={() => handleSort("title")}
                      ></i>
                    </th>)}
                    {selectedOption.length !== 0 && selectedOption.includes("patient_name") && (
                      <th>Patient Name</th>)}
                    {selectedOption.length !== 0 && selectedOption.includes("type") && (
                      <th>Application Type</th>
                    )}
                    {selectedOption.length !== 0 && selectedOption.includes("created_at") && (
                      <th>Created at</th>
                    )}
                    {selectedOption.length !== 0 && selectedOption.includes("assigned_to") && (
                      <th>Assigned To</th>
                    )}
                    {selectedOption.length !== 0 && selectedOption.includes("status") && (
                      <th>Status</th>
                    )}
                    {selectedOption.length !== 0 && selectedOption.includes("state") && (
                      <th>Resident State</th>
                    )}
                    {selectedOption.length !== 0 && selectedOption.includes("group_eligibility") && (
                      <th>Eligibility Group</th>
                    )}
                    <th></th>
                  </tr>
                </thead>
                {paginatedApplications?.length > 0 ? (
                  paginatedApplications?.map((apln, index) => {
                    const activeStepIndex =
                      apln?.stages?.some((stage) => stage.status === "NotApproved")
                        ? apln.stages.findIndex((stage) => stage.status === "NotApproved")
                        : apln.stages.every((stage) => stage.status === "Approved")
                          ? apln.stages.length
                          : apln.stages.findIndex((stage) => stage.status === "InProcess") !== -1
                            ? apln.stages.findIndex((stage) => stage.status === "InProcess")
                            : apln.stages.findIndex((stage) => stage.status === "NotStarted") !== -1
                              ? apln.stages.findIndex((stage) => stage.status === "NotStarted")
                              : apln.stages.length - 1;

                    const activeStepStatus =
                      apln?.stages.find(step => step.status === "NotApproved")?.status ||
                      apln?.stages.find(step => step.status === "InProcess")?.status ||
                      apln?.stages.find(step => step.status === "NotStarted")?.status;

                    const activeColor = activeStepStatus === "NotApproved"
                      ? "#E44545"
                      : activeStepStatus === "InProcess"
                        ? "#ECB800"
                        : activeStepStatus === "NotStarted"
                          ? "#8B8D91"
                          : "#339900";

                    const activeTitleColor = activeStepStatus === "NotApproved"
                      ? "#E44545"
                      : activeStepStatus === "InProcess"
                        ? "#ECB800"
                        : activeStepStatus === "NotStarted"
                          ? "#8B8D91"
                          : "#339900";

                    const activeBarColor = activeStepStatus === "NotApproved"
                      ? "#E44545"
                      : activeStepStatus === "InProcess"
                        ? "#ECB800"
                        : activeStepStatus === "NotStarted"
                          ? "#8B8D91"
                          : "#339900";
                    return (<tbody key={apln?._id}>
                      <tr>
                        <td colSpan={9} height={5} className="bg_light"></td>
                      </tr>
                      <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                        <td className="check_in p-2">
                          <Form>
                            <FormGroup check inline>
                              <Input
                                type="checkbox"
                                checked={isChecked(apln._id)}
                                onChange={() => handleSelect(apln._id)}
                              />
                            </FormGroup>
                          </Form>
                        </td>
                        <td
                          className="check_in p-0"
                          onClick={() => handleExpand(apln?._id)}
                        >
                          <i
                            className={
                              expandedOrg.includes(apln?._id)
                                ? "fas fa-caret-down"
                                : "fas fa-caret-right"
                            }
                          ></i>
                        </td>
                        {selectedOption.length !== 0 &&
                          selectedOption.includes("title") && (
                            <td>
                              <Link to={"/app/application-detail"} className="d-flex flex-column gap-1" state={{ applicationData: apln }} >
                              {apln?.title}
                              <button className="pending_blk">
                                  Pending Tasks:{" "}
                                  {calculatePendingTasks(apln.tasks).toString().padStart(2, "0")}
                              </button>
                              </Link>
                            </td>
                          )}
                        {selectedOption?.length !== 0 &&
                          selectedOption?.includes("patient_name") && (
                            <td className="d-flex flex-column gap-2">
                              <Link to={"/clinic/patient-profile"} className="title_name" state={{ patientData: apln?.patientData?._id }}>
                                {decryptData(apln?.patientData?.name[0].text)}
                              </Link>
                              {(() => {
                                const birthDate = decryptData(
                                  apln?.patientData?.birthDate
                                );
                                const formattedBirthDate = birthDate
                                  ? moment(birthDate).format("DD-MM-YYYY")
                                  : "Unknown Date";
                                const gender =
                                  decryptData(apln?.patientData?.gender) ||
                                  "Unknown Gender";
                                const age = formattedBirthDate
                                  ? calculateAge(formattedBirthDate)
                                  : "Unknown Age";

                                return `${age} | ${gender} | 110334343`;
                              })()}
                            </td>
                          )}
                        {selectedOption.length !== 0 &&
                          selectedOption.includes("type") && (
                            <td>{apln?.applicationType?.applicationTitle}</td>
                          )}
                        {selectedOption.length !== 0 &&
                          selectedOption.includes("created_at") && (
                            <td>
                              {moment(apln?.createdAt).format("MM-DD-YYYY")}
                            </td>
                          )}
                        {selectedOption.length !== 0 &&
                          selectedOption.includes("assigned_to") && (
                            <td>
                              <Select
                                label="Select Staff"
                                placeholder="Select"
                                value={apln?.consultantUser?._id} // Get selected staff for the patient
                                onChange={(e) =>
                                  handleUpdate(apln._id, { consultantId: e.target.value === "" ? null : e.target.value }, apln?.patientData?._id)
                                } // Assign staff to this patient
                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                {staffList?.map((option) => (
                                  <MenuItem
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </td>
                          )}
                        {selectedOption.length !== 0 &&
                          selectedOption.includes("status") && (
                            <td>
                             {stageStatusOption.find(option => option.value === apln?.status)?.label || '-'}
                            </td>
                          )}
                        {selectedOption.length !== 0 &&
                          selectedOption.includes("state") && <td>{decryptData(apln?.patientData?.address[0].state)}</td>}
                          {(selectedOption.length !== 0 && selectedOption.includes("group_eligibility")) && (
                          <td>
                            {(Array.isArray(apln?.patientData?.medicaidElegibitlyGroup) && apln?.patientData?.medicaidElegibitlyGroup.length > 0)
                              ? apln?.patientData?.medicaidElegibitlyGroup.join(", ")
                              : " "}
                          </td>
                        )}
                        <td>
                          <Link to={"/app/application-detail"} state={{ applicationData: apln }} className="d-flex flex-column gap-1 align-items-center"><i className="fa fa-external-link"></i>View Details</Link>
                        </td>
                      </tr>
                      {expandedOrg.includes(apln?._id) && (
                        <tr className="table_collapse_row ">
                          <td colSpan={11}>
                            <div className="description_application_block first">
                              <div className="tracker">
                                <div>
                                  <Stepper
                                    activeColor={activeColor}
                                    defaultColor="#8B8D91"
                                    completeColor="#339900"
                                    activeTitleColor={activeTitleColor}
                                    completeTitleColor="#339900"
                                    activeBarColor={activeBarColor}
                                    completeBarColor="#339900"
                                    steps={apln?.stages.map((step) => ({
                                      title: (
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                          <span>{step?.name}</span>
                                          {step?.status === "InProcess" && (
                                            <button
                                              style={{
                                                marginLeft: '10px',
                                                backgroundColor: '#ECB800',
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '4px 8px',
                                                cursor: 'pointer'
                                              }}
                                            >
                                              Current Stage
                                            </button>
                                          )}
                                          {step?.status === "NotApproved" && (
                                            <button
                                              style={{
                                                marginLeft: "10px",
                                                backgroundColor: "#E44545", // Red for rejected
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "4px",
                                                padding: "4px 8px",
                                                cursor: "pointer"
                                              }}
                                            >
                                              Not Approved
                                            </button>
                                          )}
                                        </div>
                                      )
                                    }))}
                                    activeStep={activeStepIndex}
                                  />
                                </div>
                              </div>
                              <h6 className="title_description">Application Summary</h6>
                              <p className="desc_application mb-3">
                                <span>Application : </span>
                                {decryptData(apln?.patientData?.name[0].text)} | {apln?.eligibilityCriteria?.age} | {apln?.eligibilityCriteria?.stateOfResidence?.label} - {apln?.title}
                              </p>
                              <div className="d-flex justify-content-between align-items-start">
                                <div className="left_desc_group">
                                  <div className="d-flex align-items-start gap-2 mb-3">
                                    <p className="desc_application">
                                      <span>Consultant :  </span>
                                    </p>
                                    <p className="desc_application">
                                      {apln.consultantUser ? (
                                        <span>{apln.consultantUser?.firstName + " " + apln.consultantUser?.lastName}</span>
                                      ) : (
                                        <span>No Consultant assigned.</span>
                                      )}
                                      <br />
                                      <i className="fa fa-envelope"></i> {apln?.consultantUser?.email}
                                    </p>
                                  </div>
                                  <div className="d-flex align-items-center gap-2 mb-3">
                                    <p className="desc_application">
                                      <span>Active Days : </span>
                                    </p>
                                    <p className="desc_application">45 days</p>
                                  </div>
                                </div>
                                <div className="right_desc_group">
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                      <p className="desc_application">
                                        <span>Medicaid Enrollment Status : </span>
                                      </p>
                                      <p className="desc_application">
                                        {apln?.patientData?.medicaidEnrollmentStatus}
                                      </p>
                                    </div>
                                    {apln?.patientData?.medicaidEnrollmentStatus === "Denied" && (
                                      <>
                                        <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                          <p className="desc_application">
                                            <span>Medicaid Denied Code : </span>
                                          </p>
                                          <p className="desc_application">
                                            {apln?.patientData?.medicaidDeniedCode}
                                          </p>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                          <p className="desc_application">
                                            <span>Medicaid Enrollment Reason : </span>
                                          </p>
                                          <p className="desc_application">
                                            {apln?.patientData?.medicaidDeniedReason && decryptData(apln?.patientData?.medicaidDeniedReason)}
                                          </p>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                    <p className="desc_application">
                                      <span>Latest Update : </span>
                                    </p>
                                    <p className="desc_application">{apln?.latestUpdate}</p>
                                  </div>
                                  <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                                    <p className="desc_application">
                                      <span>Application Notes : </span>
                                    </p>
                                  </div>
                                  <div className="d-flex gap-3 mb-3 align-items-center">
                                    <Form className="text_block">
                                      <Input
                                        id="exampleText"
                                        name="text"
                                        type="textarea"
                                        className="text_area_blk"
                                        value={applicationNote[apln._id] ?? apln?.latestCaseNote ?? ''}
                                        onChange={(e) => {
                                          handleNoteChange(apln._id, e.target.value);
                                        }}
                                        onClick={() => handleEditClick(apln._id)}
                                      />
                                    </Form>
                                    <div className="d-flex gap-3">
                                      {(applicationNote[apln._id] !== undefined && applicationNote[apln._id] !== apln?.latestCaseNote) ? (
                                        <i
                                          className="fa fa-floppy-disk"
                                          onClick={() => handleUpdate(apln._id, { latestCaseNote: applicationNote[apln._id] }, apln?.patientData?._id)}
                                          style={{ cursor: 'pointer' }}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-edit"
                                          onClick={() => handleEditClick(apln._id)}
                                          style={{ cursor: 'pointer' }}
                                        />
                                      )}
                                      {apln?.latestCaseNote !== "" && (
                                        <i
                                          className="fas fa-trash-alt"
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => handleDeleteClick(apln._id, { latestCaseNote: "" })}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>);
                  })
                ) : (
                  <tr>
                    <td colSpan={10}>
                      <p className="text-center">No Data Found</p>
                    </td>
                  </tr>
                )}
              </table>
            </div>
            <div className="paginator_block mt-3">
              <CustomPagination
                tableData={filteredApplications?.items}
                totalPages={filteredApplications?.totalPages}
                totalRows={filteredApplications?.length}
                rowsPerPage={ITEMS_PER_PAGE}
                page={currentPage}
                handlePage={handlePagination}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

AdminApplications.propTypes = {
  direction: PropTypes.oneOf([20, 10, 20, 20])
};
export default AdminApplications;
